import ValidateTabRoute from './subpages/validate-tab/route.js'
import UploadTabRoute from './subpages/upload-tab/route'
import AdminTabRoute from './subpages/admin-tab/route'
import AnalysisRoute from './subpages/analysis-tab/route'

export default {
  path: '/research-output',
  component: () => import('./ResearchOutput'),
  meta: {
    requiresAuth: true,
    requiresRoAccess: true
  },
  children: [ValidateTabRoute, UploadTabRoute, AdminTabRoute, AnalysisRoute],
  redirect: '/research-output/validate'
}
